module.exports = __webpack_public_path__ + "media/images/purchased_img-bd6ddf25a15cbbaf49ed4aae6964a9e6.svg";